import { Injectable } from '@angular/core';
import { ContentBlock } from './models/content-block';
import { ContentBlockTypes } from './models/content-block-types';
import { MarkdownBlock } from './models/markdown-block';

@Injectable({
  providedIn: 'root',
})
export class ContentBlocksService {
  constructor() {}

  getOnlyText(blocks: ContentBlock[]): string {
    return blocks
      .map((block) => {
        switch (block.type) {
          case ContentBlockTypes.Markdown:
            return (block as MarkdownBlock).markdown;
          default:
          // noop
        }
      })
      .join('');
  }
}
